import useTimer from 'hooks/useTimer';
import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { Transmission } from 'types/transmission';

import { pauseMainTheme, pauseTransmission01, playMainTheme, playTransmission01 } from './reducer';

export const useMainTheme = () => {
  const dispatch = useAppDispatch();
  const soundPlaying = useAppSelector((state) => state.sound.soundPlaying);

  const isPlaying = useMemo(() => soundPlaying === 'mainTheme', [soundPlaying]);

  const play = useCallback(() => {
    dispatch({
      type: playMainTheme.toString(),
      meta: {
        sound: {
          play: 'mainTheme',
        },
      },
    });
  }, [dispatch]);

  const pause = useCallback(() => {
    dispatch({
      type: pauseMainTheme.toString(),
      meta: {
        sound: {
          pause: 'mainTheme',
        },
      },
    });
  }, [dispatch]);

  return { play, pause, isPlaying };
};

export const useTransmission01 = (): Transmission => {
  const audioLength = 40;
  const dispatch = useAppDispatch();
  const soundPlaying = useAppSelector((state) => state.sound.soundPlaying);

  const isPlaying = useMemo(() => soundPlaying === 'transmission01', [soundPlaying]);
  const timer = useTimer({ duration: audioLength });

  const percentage = useMemo(() => (timer.time / audioLength) * 100, [timer.time]);

  const play = useCallback(() => {
    dispatch({
      type: pauseMainTheme.toString(),
      meta: {
        sound: {
          pause: 'mainTheme',
        },
      },
    });
    dispatch({
      type: playTransmission01.toString(),
      meta: {
        sound: {
          play: 'transmission01',
        },
      },
    });
    if (timer.paused) {
      timer.resume();
    } else {
      timer.start();
    }
  }, [dispatch, timer]);

  const pause = useCallback(() => {
    timer.pause();
    dispatch({
      type: pauseTransmission01.toString(),
      meta: {
        sound: {
          pause: 'transmission01',
        },
      },
    });
  }, [dispatch, timer]);

  const stop = useCallback(() => {
    timer.stop();
    dispatch({
      type: pauseTransmission01.toString(),
      meta: {
        sound: {
          stop: 'transmission01',
        },
      },
    });
  }, [dispatch, timer]);

  return { play, pause, stop, isPlaying, percentage };
};
